export function isPositiveInteger(value: number) {
  if (Number.isNaN(value) || value < 0) return false;
  return Math.floor(value) === value;
}
